{
  "app": {
    "name": "وودكرافت ERP",
    "tagline": "تصنيع قائم على المشروعات، من عرض السعر إلى التركيب.",
    "version": "الإصدار {version}",
    "poweredBy": "بدعم من {company}",
    "copyright": "© {year} {company}"
  },
  "auth": {
    "signIn": "تسجيل الدخول",
    "signOut": "تسجيل الخروج",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "remember": "تذكّرني",
    "forgot": "نسيت كلمة المرور؟",
    "welcome": "مرحبًا بعودتك",
    "subtitle": "سجّل الدخول إلى مساحة عملك",
    "invalid": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    "locked": "محاولات كثيرة. حاول مجددًا بعد {minutes} دقيقة",
    "changePassword": "تغيير كلمة المرور",
    "currentPassword": "كلمة المرور الحالية",
    "newPassword": "كلمة المرور الجديدة",
    "confirmPassword": "تأكيد كلمة المرور",
    "passwordChanged": "تم تغيير كلمة المرور. يرجى تسجيل الدخول مجددًا.",
    "switchCompany": "تبديل الشركة",
    "language": "اللغة",
    "profile": "ملفي الشخصي"
  },
  "common": {
    "save": "حفظ",
    "saveAndNew": "حفظ وجديد",
    "cancel": "إلغاء",
    "close": "إغلاق",
    "back": "رجوع",
    "new": "جديد",
    "create": "إنشاء",
    "edit": "تعديل",
    "delete": "حذف",
    "deactivate": "تعطيل",
    "reactivate": "إعادة تفعيل",
    "duplicate": "نسخ",
    "search": "بحث",
    "searchPlaceholder": "ابحث…",
    "filters": "تصفية",
    "clearFilters": "مسح التصفية",
    "export": "تصدير",
    "import": "استيراد",
    "print": "طباعة",
    "refresh": "تحديث",
    "more": "المزيد",
    "actions": "إجراءات",
    "viewAll": "عرض الكل",
    "viewDetails": "عرض التفاصيل",
    "details": "التفاصيل",
    "activity": "النشاط",
    "documents": "الوثائق",
    "approvals": "الاعتمادات",
    "notes": "ملاحظات",
    "yes": "نعم",
    "no": "لا",
    "none": "لا شيء",
    "all": "الكل",
    "today": "اليوم",
    "loading": "جارٍ التحميل…",
    "saving": "جارٍ الحفظ…",
    "saved": "تم الحفظ",
    "required": "مطلوب",
    "optional": "اختياري",
    "reason": "السبب",
    "reasonPlaceholder": "ما سبب هذا التغيير؟",
    "comment": "تعليق",
    "confirm": "تأكيد",
    "areYouSure": "هل أنت متأكد؟",
    "irreversible": "لا يمكن التراجع عن هذا الإجراء.",
    "copy": "نسخ",
    "copied": "تم النسخ",
    "select": "اختر…",
    "noResults": "لا توجد نتائج",
    "noData": "لا توجد بيانات بعد",
    "createFirst": "أنشئ أول {entity}",
    "showing": "عرض {from} إلى {to} من {total} سجل",
    "perPage": "{n} / صفحة",
    "page": "صفحة {page} من {pages}",
    "sortBy": "ترتيب حسب",
    "columns": "الأعمدة",
    "status": "الحالة",
    "createdAt": "تاريخ الإنشاء",
    "createdBy": "أنشأه",
    "updatedAt": "آخر تعديل",
    "updatedBy": "عدّله",
    "vsLastMonth": "مقارنة بالشهر الماضي",
    "vsLastYear": "مقارنة بالعام الماضي",
    "noChange": "بدون تغيير",
    "of": "من",
    "from": "من",
    "to": "إلى",
    "date": "التاريخ",
    "type": "النوع",
    "reference": "المرجع",
    "description": "الوصف",
    "user": "المستخدم",
    "amount": "المبلغ",
    "quantity": "الكمية",
    "total": "الإجمالي",
    "code": "الكود",
    "name": "الاسم",
    "remove": "إزالة"
  },
  "workflow": {
    "submit": "إرسال للاعتماد",
    "approve": "اعتماد",
    "reject": "رفض",
    "return": "إعادة",
    "decide": "القرار",
    "pending": "بانتظار الاعتماد",
    "approvedBy": "اعتمده {name}",
    "rejectedBy": "رفضه {name}",
    "step": "الخطوة {n}: {label}",
    "awaiting": "بانتظار {role}",
    "changeRequest": "طلب تغيير",
    "changePending": "أُرسل هذا التغيير للاعتماد وسيُطبَّق بعد الموافقة.",
    "commentRequired": "التعليق مطلوب عند الرفض أو الإعادة",
    "reasonRequired": "السبب مطلوب",
    "inbox": "صندوق الاعتمادات",
    "nothingToApprove": "لا يوجد ما ينتظر اعتمادك",
    "requestedBy": "طلبه",
    "requestedAt": "تاريخ الطلب"
  },
  "errors": {
    "validation": "يرجى تصحيح الحقول المحددة",
    "forbidden": "ليست لديك صلاحية لهذا الإجراء",
    "notFound": "السجل غير موجود",
    "conflict": "يتعارض هذا مع سجل موجود",
    "unknown": "حدث خطأ ما. يرجى المحاولة مجددًا.",
    "network": "تعذر الوصول إلى الخادم",
    "sessionExpired": "انتهت جلستك. يرجى تسجيل الدخول مجددًا.",
    "noAccessTitle": "هذه الشاشة ليست ضمن مصفوفة صلاحياتك",
    "noAccessHint": "اطلب من مدير النظام منحها (الإدارة ← مصفوفة الصلاحيات)"
  },
  "audit": {
    "title": "سجل المراجعة",
    "changed": "{user} غيّر {field} من {old} إلى {new}",
    "created": "{user} أنشأ هذا السجل",
    "deleted": "{user} حذف هذا السجل",
    "noChanges": "لا توجد تغييرات مسجلة",
    "field": "الحقل",
    "old": "القيمة القديمة",
    "new": "القيمة الجديدة"
  },
  "home": {
    "welcome": "مرحبًا، {name}",
    "quickActions": "إجراءات سريعة",
    "recentActivities": "آخر الأنشطة",
    "upcomingTasks": "المهام القادمة",
    "pendingApprovals": "اعتمادات معلقة",
    "kpi": {
      "activeProjects": "المشروعات النشطة",
      "salesYtd": "المبيعات (منذ بداية العام)",
      "purchasesYtd": "المشتريات (منذ بداية العام)",
      "productionOutput": "الإنتاج",
      "pendingInvoices": "فواتير معلقة",
      "employees": "الموظفون",
      "customers": "العملاء",
      "suppliers": "الموردون",
      "items": "الأصناف"
    },
    "comingDay": "متاح في يوم البناء {day}"
  },
  "nav": {
    "settings": "الإعدادات",
    "help": "المساعدة والدعم",
    "notifications": "الإشعارات",
    "markAllRead": "تحديد الكل كمقروء",
    "noNotifications": "لا توجد إشعارات",
    "search": "بحث (العملاء، المشروعات، الأصناف، الوثائق…)",
    "comingSoon": "هذه الشاشة مخططة ليوم البناء {day}",
    "setup": "الإعداد والبيانات الرئيسية",
    "plannedScope": "النطاق المخطط",
    "home": "الرئيسية"
  },
  "footer": {
    "privacy": "الخصوصية",
    "terms": "الشروط",
    "support": "الدعم",
    "english": "English",
    "arabic": "العربية",
    "egypt": "مصر"
  },
  "admin": {
    "users": "المستخدمون",
    "roles": "الأدوار والصلاحيات",
    "addUser": "إضافة مستخدم",
    "inviteSent": "تم إنشاء المستخدم. كلمة المرور المؤقتة: {password}",
    "permissionMatrix": "مصفوفة الصلاحيات",
    "organization": "الهيكل التنظيمي",
    "settings": "إعدادات النظام",
    "numbering": "ترقيم المستندات",
    "auditLog": "سجل المراجعة",
    "systemInfo": "معلومات النظام",
    "workflows": "سير العمل",
    "integrations": "التكاملات",
    "companyInfo": "بيانات الشركة",
    "backup": "نسخ احتياطي",
    "authorization": "مصفوفة الصلاحيات",
    "authorizationHint": "أي الشاشات تُفتح، وأي التقارير تُشغَّل، وأي الوظائف تُنفَّذ — لكل دور، مع استثناءات لكل مستخدم ونطاقات البيانات",
    "matrixRoles": "الأدوار",
    "matrixUsers": "المستخدمون",
    "kind_screen": "الشاشات",
    "kind_report": "التقارير",
    "kind_function": "الوظائف",
    "allModules": "كل الوحدات",
    "everything": "كل شيء (*)",
    "everythingNeedsConfigure": "منح كل شيء يتطلب صلاحية تهيئة الأدوار",
    "members": "أعضاء",
    "viaPattern": "ممنوح عبر",
    "unsavedRoles": "تغيّر {n} دور — احفظ للتطبيق",
    "matrixLegend": "صف الوحدة يمنح الوحدة كاملة؛ الخلايا المظللة قادمة من نمط عام",
    "owner": "المالك",
    "noRoles": "بدون أدوار",
    "ownerNote": "مالكو المنشأة يتجاوزون المصفوفة: لا ينطبق عليهم سوى المنع أدناه",
    "pickUser": "اختر مستخدمًا",
    "pickUserHint": "اختر مستخدمًا على اليسار لعرض وتغيير صلاحياته الفعلية ونطاقات بياناته",
    "dataScopes": "نطاقات البيانات",
    "dataScopesHint": "قصر المستخدم على شركات أو فروع أو مشروعات أو مخازن أو مراكز تكلفة محددة. غير مقيّد يعني كل السجلات؛ البعد المقيّد يُظهر فقط السجلات التابعة للمختار (السجلات بلا قيمة له تبقى ظاهرة).",
    "unrestricted": "غير مقيّد",
    "confinedTo": "مقيّد بـ {n}",
    "saveScopes": "حفظ نطاقات البيانات",
    "effectiveAccess": "الصلاحيات الفعلية",
    "effective": "الفعلي",
    "grantedVia": "ممنوح عبر",
    "override": "استثناء",
    "override_inherit": "موروث من الأدوار",
    "override_allow": "سماح",
    "override_deny": "منع",
    "allowed": "مسموح",
    "refused": "مرفوض",
    "overrideHint": "المنع يتغلب على كل منح الأدوار؛ السماح يُضاف إليها",
    "saveOverrides": "حفظ الاستثناءات"
  },
  "ui": {
    "always": "دائمًا",
    "attachPdf": "إرفاق PDF بالسجل",
    "columns": "الأعمدة",
    "computeKpis": "احتساب المؤشرات الآن",
    "computeKpisHint": "تُحفظ المؤشرات يوميًا بواسطة المجدول؛ احتسبها الآن لرؤية قيم اليوم.",
    "configure": "إعداد",
    "connectors": "الموصّلات",
    "csvFile": "ملف CSV",
    "customise": "تخصيص",
    "customised": "مخصّص",
    "days": "يوم",
    "deactivatedRecord": "هذا السجل معطّل. يبقى للتاريخ والتقارير؛ أعد تفعيله لاستخدامه مجددًا.",
    "enabled": "مفعّل",
    "events": "الأحداث",
    "eventsHint": "يُنشر هنا كل سجل جديد وكل اكتمال لسير عمل عند تفعيل Webhooks.",
    "failed": "فشل",
    "jobTitle": "المسمى الوظيفي",
    "keyField": "مطابقة السجلات الموجودة بواسطة",
    "keyFieldHint": "السجلات التي يتطابق مفتاحها مع سجل موجود تُحدَّث بدلًا من إنشائها.",
    "kpis": "مؤشرات الأداء الرئيسية",
    "languageHint": "تتبع الشاشات والمستندات المطبوعة والبريد لغتك.",
    "lastLogin": "آخر دخول",
    "nextValue": "الرقم التالي",
    "nextValueHint": "اتركه فارغًا للإبقاء على العدّاد الحالي.",
    "numberingHint": "البادئة والنمط لكل نوع مستند. الرموز:",
    "passwordMismatch": "كلمتا المرور الجديدتان غير متطابقتين",
    "passwordPolicy": "10 أحرف على الأقل مع حروف وأرقام ورمز.",
    "pattern": "النمط",
    "pickRole": "اختر دورًا من القائمة لعرض صلاحياته وتعديلها.",
    "prefix": "البادئة",
    "preview": "معاينة",
    "projectProgress": "تقدم المشروعات",
    "reports": "التقارير",
    "requiresApproval": "يتطلب اعتمادًا",
    "resetDefault": "العودة إلى سير العمل الأصلي",
    "resetDefaultHint": "يُعطَّل إعداد الشركة ويُطبَّق سير العمل الأصلي مجددًا. تبقى الإصدارات في السجل.",
    "resetYearly": "إعادة الترقيم سنويًا",
    "row": "صف",
    "rows": "صفوف",
    "runQuery": "تشغيل الاستعلام",
    "runReport": "تشغيل التقرير",
    "shareSecurely": "شاركها مع المستخدم عبر قناة آمنة؛ تُعرض مرة واحدة فقط.",
    "shipped": "الأصلي",
    "shippedSteps": "الخطوات الأصلية",
    "target": "المستهدف",
    "template": "قالب",
    "temporaryPassword": "كلمة مرور مؤقتة",
    "test": "اختبار",
    "timezone": "المنطقة الزمنية",
    "transitions": "إجراءات",
    "unmapped": "أعمدة غير مطابقة",
    "validate": "تحقق",
    "versions": "الإصدارات",
    "wildcardGrants": "صلاحيات عامة (*)",
    "workflowNoteHint": "سبب هذا الإعداد (قرار مجلس الإدارة، مرجع السياسة)…",
    "workflowsHint": "مصفوفات الاعتماد لكل مستند: من يعتمد، والحدود، والإجراءات المسموح بها.",
    "poweredBy": "بواسطة {product}"
  },
  "brand": {
    "title": "الهوية البصرية والعلامة الخاصة",
    "sub": "اسمكم وشعاركم وألوانكم على كل شاشة وكل مستند مطبوع في هذا الحساب.",
    "identity": "الهوية",
    "appName": "اسم التطبيق",
    "appNameHint": "يظهر في القائمة الجانبية وعنوان المتصفح وشاشة الدخول — مثل \"Grove ERP\".",
    "tagline": "الشعار النصي (إنجليزي)",
    "taglineAr": "الشعار النصي (عربي)",
    "poweredBy": "سطر \"بواسطة\"",
    "poweredByHint": "يظهر في أسفل الشاشة وعلى المستندات المطبوعة. أوقفه لإخفاء اسم المنتج بالكامل.",
    "productName": "اسم المنتج",
    "logos": "الشعارات",
    "logo": "الشعار",
    "logoHint": "شعار أفقي بصيغة SVG أو PNG بخلفية شفافة أو بيضاء (حتى 400 كيلوبايت). يُستخدم في القائمة الجانبية وشاشة الدخول والمستندات المطبوعة عندما لا يكون للشركة شعار خاص.",
    "mark": "العلامة (مربعة)",
    "markHint": "نسخة مربعة صغيرة للقائمة المطوية وأيقونة المتصفح. اختياري — يُستخدم الشعار عند تركه فارغًا.",
    "noLogo": "لا توجد صورة",
    "upload": "رفع صورة",
    "replace": "استبدال",
    "tooLarge": "الصورة كبيرة جدًا — الحد الأقصى {kb} كيلوبايت.",
    "unsupported": "استخدم صورة بصيغة SVG أو PNG أو JPEG أو WebP.",
    "colours": "الألوان",
    "primary": "اللون الأساسي",
    "primaryHint": "الأزرار والروابط والعناصر النشطة والرسوم البيانية.",
    "accent": "لون التمييز",
    "accentHint": "الإبرازات والعلامات.",
    "sidebar": "القائمة الجانبية",
    "sidebarHint": "خلفية شريط التنقل. يتكيف لون النص تلقائيًا.",
    "preview": "معاينة",
    "previewHint": "ما سيراه كل مستخدمي هذا الحساب بعد الحفظ. يمكن أيضًا تعيين شعار كل شركة على المستندات المطبوعة (الإدارة ← بيانات الشركة).",
    "reset": "استعادة الافتراضي",
    "saved": "تم حفظ الهوية البصرية — وتطبيقها على كل الشاشات والمستندات المطبوعة.",
    "storedIssues": "بعض القيم المخزنة غير صالحة وتم استبدالها بالافتراضي",
    "sampleModule": "المبيعات والعملاء",
    "sampleModule2": "المشتريات",
    "sampleKpi": "إيرادات هذا الشهر",
    "sampleDoc": "عرض سعر QT-2026-0001",
    "sampleFooter": "طبعه مدير النظام"
  },
  "ai": {
    "assistant": "المساعد",
    "conversations": "المحادثات",
    "newConversation": "محادثة جديدة",
    "noConversations": "لا توجد محادثات بعد",
    "intro": "اسأل عن أي شيء في النظام — سجلات، أرقام، ما يحتاج انتباهًا — أو اطلب مني تجهيز سجل لتؤكده.",
    "thinking": "جارٍ التفكير…",
    "placeholder": "اسأل، أو قل ما تريد تجهيزه… (Enter للإرسال)",
    "send": "إرسال",
    "lines": "بند",
    "openDraft": "فتح المسودة",
    "openScreen": "فتح",
    "mockNote": "المزوّد التجريبي مفعّل: الإجابات مؤقتة حتى يُهيّأ نموذج (الإدارة ← التكاملات ← المساعد الذكي).",
    "starterSummarise": "لخّص هذا السجل",
    "starterNext": "ما الخطوة التالية في هذا السجل؟",
    "starterRisks": "هل يوجد خطأ أو تأخير هنا؟",
    "starterOverdue": "ما فواتير العملاء المتأخرة؟",
    "starterStock": "ما الأصناف تحت حد إعادة الطلب؟",
    "starterProjects": "ما المشروعات الخاسرة؟",
    "searchPlaceholder": "ابحث، أو صف ما تريد إيجاده…",
    "askSearch": "اطلب من الذكاء الاصطناعي إيجاد: \"{text}\"",
    "menu": "الذكاء الاصطناعي",
    "summarise": "تلخيص",
    "summary": "الملخص",
    "askAbout": "اسأل عن هذا السجل",
    "draftEmail": "صياغة بريد عن هذا",
    "draftField": "صياغة بالذكاء الاصطناعي",
    "translateTo": "ترجمة إلى {lang}",
    "insights": "رؤى اليوم",
    "insightsEmpty": "لا شيء يحتاج انتباهًا الآن.",
    "refresh": "تحديث",
    "generatedBy": "صاغه {model}",
    "applyLines": "جارٍ إنشاء {n} بند…",
    "linesCreated": "تم إنشاء {n} بند",
    "extractLines": "استخراج بنود من نص",
    "extractHint": "الصق عرض سعر مورد أو جدول كميات أو أي نص يحوي بنودًا",
    "extractRun": "استخراج",
    "extractResult": "تم العثور على {n} بند",
    "addLines": "إضافة {n} بند",
    "copy": "نسخ",
    "useText": "استخدام هذا النص"
  },
  "trace": {
    "scan": "مسح",
    "title": "مسح وتتبع",
    "intro": "امسح بطاقة أو ملصقًا بالماسح أو الكاميرا، أو اكتب الكود — إذن استلام، دفعة، صنف، أصل، فحص، بطاقة موظف…",
    "placeholder": "امسح أو اكتب الكود (GRN-2026-0024، LOT-2026-00007، RW-001، AST-2026-0004…)",
    "resolve": "بحث",
    "camera": "مسح بالكاميرا",
    "stopCamera": "إيقاف الكاميرا",
    "cameraUnsupported": "هذا المتصفح لا يقرأ الرموز من الكاميرا (كروم على أندرويد وكروميوم الحديث يفعلان). استخدم ماسحًا أو اكتب الكود.",
    "cameraDenied": "تم رفض الوصول إلى الكاميرا أو أنها غير متاحة.",
    "notFound": "لا يوجد سجل يحمل الكود {code} — أو أنه خارج صلاحياتك.",
    "lineOf": "بند من",
    "open": "فتح",
    "actions": "الخطوات التالية",
    "facts": "التفاصيل",
    "trace": "التتبع",
    "origin": "المصدر",
    "receipt": "الاستلام",
    "supplier": "المورد",
    "purchaseOrder": "أمر الشراء",
    "inspection": "الفحص",
    "balances": "أين هي الآن",
    "movements": "الحركات",
    "noMovements": "لا حركات بعد",
    "onHand": "الرصيد",
    "reserved": "محجوز",
    "warehouse": "المخزن",
    "qty": "الكمية",
    "document": "المستند",
    "type": "النوع",
    "date": "التاريخ",
    "project": "المشروع",
    "workOrder": "أمر التشغيل",
    "code": "كود المسح",
    "printLabels": "طباعة البطاقات",
    "labels": "بطاقات",
    "labelSize": "مقاس البطاقة",
    "size50": "حراري 50 × 30 مم",
    "size100": "حراري 100 × 50 مم",
    "sizeA4": "ورقة A4 (2 × 6)",
    "scanHistory": "سجل المسح",
    "noScans": "لم يُمسح بعد",
    "scannedBy": "{user} · {when}",
    "purpose": "الغرض",
    "recent": "مسحات هذه الجلسة",
    "copyCode": "نسخ الكود",
    "qrHint": "وجّه كاميرا الهاتف إلى رمز QR لفتح هذا السجل في شاشة المسح",
    "unknownKind": "غير معروف",
    "kind_document": "مستند",
    "kind_line": "بند",
    "kind_lot": "دفعة",
    "kind_item": "صنف",
    "kind_asset": "أصل",
    "kind_person": "موظف"
  },
  "docs": {
    "recycleBin": "سلة المحذوفات",
    "recycleBinIntro": "الوثائق التي أُزيلت من مجلداتها. الاستعادة تعيد الوثيقة إلى مكانها بإصداراتها وروابطها.",
    "binEmpty": "سلة المحذوفات فارغة",
    "binEmptyHint": "الوثائق المنقولة إلى سلة المحذوفات من صفحة السجل تظهر هنا.",
    "binHint": "تُزال الوثائق من صفحتها (نقل إلى سلة المحذوفات)؛ الوثائق المعتمدة تحتاج مدير وثائق. العودة إلى",
    "restore": "استعادة",
    "restored": "تمت استعادة الوثيقة ✓",
    "number": "رقم الوثيقة",
    "title": "العنوان",
    "category": "الفئة",
    "folder": "المجلد",
    "version": "الإصدار",
    "deletedAt": "حُذفت في",
    "deletedBy": "حذفها"
  }
}
